import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA4_ID;
const KEY = "sb-analytics-consent";
export const openCookieSettings = () => window.dispatchEvent(new Event("sb-cookie-settings"));
export const analyticsEnabled = !!GA_ID;

const gtag = (...args) => { window.dataLayer = window.dataLayer || []; window.dataLayer.push(args); };

const loadGa = () => {
  if (window.__sbGa) return;
  window.__sbGa = true;
  window.gtag = gtag;
  gtag("consent", "default", { analytics_storage: "denied", ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied" });
  gtag("consent", "update", { analytics_storage: "granted" });
  gtag("js", new Date());
  gtag("config", GA_ID, { send_page_view: false });
  const s = document.createElement("script");
  s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
};

// GA4 stays completely off (no banner, no script) unless REACT_APP_GA4_ID is set and the visitor accepts.
export const Consent = () => {
  const { pathname } = useLocation();
  const [choice, setChoice] = useState(() => { try { return localStorage.getItem(KEY); } catch { return "denied"; } });
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener("sb-cookie-settings", show);
    return () => window.removeEventListener("sb-cookie-settings", show);
  }, []);
  useEffect(() => {
    if (GA_ID && choice === "granted" && !pathname.startsWith("/admin")) {
      loadGa();
      window.gtag("event", "page_view", { page_path: pathname, page_location: window.location.href });
    }
  }, [choice, pathname]);
  if (!GA_ID || pathname.startsWith("/admin") || (choice && !open)) return null;

  const decide = (v) => {
    try { localStorage.setItem(KEY, v); } catch { /* storage blocked */ }
    if (v === "denied" && window.__sbGa) window.gtag("consent", "update", { analytics_storage: "denied" });
    setChoice(v); setOpen(false);
  };
  return (
    <div role="dialog" aria-label="Cookie choices" className="fixed inset-x-3 bottom-3 sm:left-auto sm:right-4 sm:max-w-sm z-50 rounded-2xl bg-[#202A35] text-white p-4 shadow-xl" data-testid="cookie-banner">
      <p className="text-sm leading-relaxed">We'd like to use Google Analytics cookies to understand how the shop is used. They're optional and only set if you accept. <a href="/info/cookie-policy" className="underline font-semibold text-[#FFD23F]">Cookie Policy</a></p>
      <div className="mt-3 flex gap-2">
        <button onClick={() => decide("granted")} className="flex-1 h-10 rounded-full bg-[#FFD23F] text-[#202A35] text-sm font-bold" data-testid="cookie-accept">Accept analytics</button>
        <button onClick={() => decide("denied")} className="flex-1 h-10 rounded-full border-2 border-white/60 text-sm font-bold" data-testid="cookie-reject">Reject</button>
      </div>
    </div>
  );
};
